// @ts-check

/**
 * @file Defines an Expo route wrapper.
 */
import _ from "gettext-universal/build/src/translate.js"
import useLocale from "gettext-universal/build/src/use-locale-expo.js"
import {memo} from "react"
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component.js"
import TaskTypeEditScreen from "../../src/screens/task-types/edit-screen"
import ScreenTitle from "../../src/components/screen-title"

/** @import {NamedExoticComponent, ReactNode} from "react" */

/** @typedef {{[key: string]: unknown}} TaskTypeNewRouteProps */

/** @typedef {Record<string, never>} TaskTypeNewRouteState */

/**
 * Renders an Expo route screen.
 * @augments {ShapeComponent<TaskTypeNewRouteProps, TaskTypeNewRouteState>}
 */
class TaskTypeNewRoute extends ShapeComponent {
  /** Initializes route hooks. */
  setup() {
    useLocale()
  }

  /**
   * Renders route content.
   * @returns {ReactNode} Rendered route content.
   */
  render() {
    return (
      <>
        <ScreenTitle>{_("New task type")}</ScreenTitle>
        <TaskTypeEditScreen />
      </>
    )
  }
}

/** @type {NamedExoticComponent<TaskTypeNewRouteProps>} */
const TaskTypeNewRouteComponent = memo(shapeComponent(TaskTypeNewRoute))

export default TaskTypeNewRouteComponent
